import React, { useEffect } from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { theme } from "@common/theme/theme"

const QualityClosureRedirect = ({ navigation, route }) => {
    useEffect(() => {
        navigation.replace("end-session-tutor", route?.params ?? {})
    }, [])

    return (
        <View
            style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: theme.colors.greyBg,
            }}
        >
            <ActivityIndicator
                animating
                color={theme.colors.primary}
                size="large"
            />
        </View>
    )
}

export default QualityClosureRedirect
